module.exports = __webpack_public_path__ + "static/media/page-header-bg-1.e977c20e.jpg";